/* eslint-disable import/prefer-default-export */
export enum PerformanceDescriptionStatus {
  APPROVED = 'APPROVED',
  REJECTED = 'REJECTED',
  DRAFT = 'DRAFT',
  PENDING_APPROVAL = 'PENDING_APPROVAL'
}
